// Compact hover/tap tooltip for the sheet tables' target + note text (Joey, Oct 29 2026 6:34 PM ET: the Average sale price
// explanation "just covers all the other tabs and it doesn't look clean"). The cell shows one truncated line; the full text
// opens in a small card (max 300 px) rendered in a portal, so the table's scroll box never clips or widens because of it.
import { useEffect, useRef, useState, type CSSProperties, type ReactNode } from "react";
import { createPortal } from "react-dom";

const TIP_WIDTH = 300;

export function HoverTip({ text, children, className, style, toggleOnClick = true, tabIndex }: { text: ReactNode; children: ReactNode; className?: string; style?: CSSProperties; toggleOnClick?: boolean; tabIndex?: number }) {
  const ref = useRef<HTMLSpanElement>(null);
  const [pos, setPos] = useState<{ left: number; top: number; above: boolean } | null>(null);
  const show = () => {
    const el = ref.current; if (!el || !text) return;
    const r = el.getBoundingClientRect();
    const above = window.innerHeight - r.bottom < 140 && r.top > 140;
    setPos({ left: Math.max(8, Math.min(r.left, window.innerWidth - TIP_WIDTH - 8)), top: above ? r.top - 6 : r.bottom + 6, above });
  };
  const hide = () => setPos(null);
  useEffect(() => {
    if (!pos) return;
    const close = () => setPos(null);
    window.addEventListener("scroll", close, true); window.addEventListener("resize", close);
    return () => { window.removeEventListener("scroll", close, true); window.removeEventListener("resize", close); };
  }, [pos]);
  return <span ref={ref} className={className} style={style} tabIndex={tabIndex} onMouseEnter={show} onMouseLeave={hide} onFocus={show} onBlur={hide}
    onClick={toggleOnClick ? () => (pos ? hide() : show()) : undefined} onKeyDown={(event) => { if (event.key === "Escape") hide(); }}>
    {children}
    {pos && typeof document !== "undefined" && createPortal(<div role="tooltip" data-hover-tip
      className="pointer-events-none fixed z-[120] rounded-md border border-slate-200 bg-white px-2.5 py-1.5 text-left text-[11px] font-medium leading-snug text-slate-800 shadow-lg"
      style={{ left: pos.left, top: pos.top, maxWidth: TIP_WIDTH, width: "max-content", whiteSpace: "normal", wordBreak: "break-word", transform: pos.above ? "translateY(-100%)" : undefined, fontFamily: "system-ui, sans-serif" }}>{text}</div>, document.body)}
  </span>;
}
